import React, { useState } from "react";
import {
  Button,
} from "reactstrap";
import TextareaAutosize from 'react-textarea-autosize';
import ApiCaller from "../../../../api/apiCaller";
import "./index.css";

interface SiteCommentBoxInputProps {
  sitePlanningSelectionAreaId: any;
  onCommentSaved?: Function;
  onCancelClicked?: Function;
  comment?: any;
}

const SiteCommentTab = ({
  sitePlanningSelectionAreaId,
  onCommentSaved,
  onCancelClicked,
  comment,
}: SiteCommentBoxInputProps) => {
  const [commentData, setCommentData] = useState<any>({
    site_planning_selection_area_id: parseInt(comment?.site_planning_selection_area_id || sitePlanningSelectionAreaId, 10),
    ...comment,
  });
  const [isSaving, setIsSaving] = useState<boolean>(false);

  const saveComment = async () => {
    let uri = '';
    let res = null;
    setIsSaving(true);
    if (commentData?.id) {
      // Update mode
      uri = `site_planning_selection_area_comment/${commentData.id}`;
      res = await ApiCaller.put(
        uri,
        commentData,
      );
    } else {
      // Create mode
      uri = `site_planning_selection_area_comment/`;
      res = await ApiCaller.post(
        uri,
        commentData,
      );
    }
    if (res?.result) {
      setIsSaving(false);
      if (onCommentSaved) {
        onCommentSaved(commentData);
      }
      const newCommentData = {
        ...commentData,
        content: '',
      };
      setCommentData(newCommentData);
    } else {
      setIsSaving(false);
    }
  }

  const cancelEditComment = () => {
    if (onCancelClicked) {
      onCancelClicked();
    }
  }

  return (
    <div style={styles.commentBoxContainer}>
      <div>
        <TextareaAutosize
          type="textarea"
          minRows={2}
          placeholder="Viết nhận xét của bạn vào đây..."
          onChange={(e:any) => setCommentData({ ...commentData, content: e.target.value })}
          value={commentData.content}
          style={styles.commentBox}
          autoFocus
        />
      </div>
      <div style={styles.commentButtonContainer}>
        {commentData.id &&
          <Button
            size="sm"
            color="secondary"
            onClick={cancelEditComment}
            style={styles.commentButton}
          >Hủy</Button>
        }
        <Button
          size="sm"
          color={isSaving || !commentData.content ? "secondary" : "primary"}
          disabled={isSaving || !commentData.content}
          onClick={saveComment}
          style={styles.commentButton}
        >{isSaving ? 'Đang đăng...' : 'Đăng'}</Button>
      </div>
    </div>
  );
}

const styles = {
  commentBoxContainer: {
    backgroundColor: 'var(--color-line-light)',
    borderRadius: 6,
  } as React.CSSProperties,
  commentBox: {
    backgroundColor: 'var(--color-line-light)',
    border: 'none',
    width: '100%',
    padding: 12,
    fontSize: 16,
  },
  commentButtonContainer: {
    backgroundColor: 'var(--color-line-light)',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-end',
    marginTop: 6,
  } as React.CSSProperties,
  commentButton: {
    marginLeft: 6,
  },
};

export default SiteCommentTab;
